import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Space,
  Table,
  Tabs,
  Tooltip,
  notification,
  Typography
} from "antd";
import { ColumnsType } from "antd/lib/table";
import iconAction from "../../../../../assets/images/action.svg";
import iconApprove from "../../../../../assets/images/apporveIcon.svg";
import { ReactComponent as IconApprove } from "../../../../../assets/images/apporveIcon.svg";
import shareIcon from "../../../../../assets/images/shareIcon.svg";
import copyIcon from "../../../../../assets/images/pixelarticons_copy.svg"
import iconCopy from "../../../../../assets/images/copy.svg";
import iconError from "../../../../../assets/images/error.svg";
import iconSearch from "../../../../../assets/images/search.png";
import API_SERVICE from "shared/services/api-service";
import DocumentStatus from "shared/components/Lead/RequiredDocuments/DocumentStatus";
import { getEnumValue, numberWithCommas } from "shared/services/Utility";
import "./Login.scss";
import LenderSelection from "./LenderSelection";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import passIcon from "../../../../../assets/images/pass.svg";
import failIcon from "../../../../../assets/images/fail.svg";
import { ReactComponent as IconRefresh } from "../../../../../assets/images/blackReferesh.svg"
import { iteratee } from "lodash";
const {Title} = Typography

interface ILogin {
  setIsLoading: any;
  leadData: any;
  updateCase: any;
  getRedirectURLLink: any;
  getCashETriggerSMSLink: any;
  callbackReqDoc: any;
  callbackAdditionalField: any;
  setShowRequirementDocs: any;
  setSelectedLander: any;
  selectedLender:any;
  setSelectedLender:any;
  setAdditionalFields: any;
  setCurrLenderId: any;
  setCurrLeadId: any;
  setShowAdditionalFields: any;
  submitTask: any;
  getTaskData: any;
  getLenderAdditonalField: any;
  lenderNextHandler: any;
  loading: any;
  getNextTask: any;
  setCallbackReqDoc: any;
  decisionData: any;
  getLenders: any;
  setProductPlanName:any;
  productPlanName:any;
  productPlanId:any;
  setProductPlanId:any;
  lenderListInsurer:any
  annualFee:any;
  setAnnualFee:any
}

const Login: React.FC<ILogin> = (props: ILogin) => {
  const {
    setIsLoading,
    leadData,
    updateCase,
    getRedirectURLLink,
    getCashETriggerSMSLink,
    callbackReqDoc,
    callbackAdditionalField,
    setShowRequirementDocs,
    setSelectedLander,
    selectedLender,
    setSelectedLender,
    setAdditionalFields,
    setCurrLenderId,
    setCurrLeadId,
    setShowAdditionalFields,
    submitTask,
    getTaskData,
    getLenderAdditonalField,
    lenderNextHandler,
    loading,
    getNextTask,
    setCallbackReqDoc,
    decisionData,
    getLenders,
    setProductPlanName,
    productPlanName,
    productPlanId,
    setProductPlanId    ,
    lenderListInsurer,
    annualFee,
    setAnnualFee
  } = props;
  const [totalCount, setTotalCount] = useState(0);
  const [showDocumentStatus, setShowDocumentStatus] = useState(false);
  const [selectedDocLender, setSelectedDocLender] = useState({} as any);
  const [documentDetails, setDocumentDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSizeMain, setPageSizeMain] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [filterListDecision, setFilterListDecision] = useState([] as any);
  const [loginOptionModal, setLoginOptionModal] = useState(false);
  const [updateStatusType, setUpdateStatusType] = useState("");
  const [aggregatorConfigId, setAggregatorConfigId] = useState("");
  const [lenderObj, setLenderObj] = useState({} as any);
  const [subProductObj, setSubProductObj] = useState({} as any);
  const [lenders, setLenders] = useState([] as any);
  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const commonFontSize = { fontSize: "13px" };
  const [loginSearchForm] = Form.useForm();
  const [showCardFeatures, setShowCardFeatures] = useState(false)
  const [offerDetails, setOfferDetails] = useState({} as any)
     
   

  useEffect(() => {
    loginSearchForm.setFieldsValue({
      searchParam: "",
    });
    // setPageNo(1);
    setLenders(decisionData);
    setTotalCount(decisionData?.length);
    setSearchValue("");
    setFilterListDecision([]);
  }, [decisionData]);

  useEffect(() => {
    if (Object?.keys(callbackAdditionalField)?.length !== 0) {
      if (
        Object.keys(callbackReqDoc).length == 0 &&
        callbackAdditionalField?.showRequirementDocs != "false"
      ) {
        setShowRequirementDocs(true);
      } else {
        if (
          getTaskData?.taskDefinitionKey == "login_stage_process_login_task"
        ) {
          const payload = {
            taskDefinitionKey: getTaskData?.taskDefinitionKey,
            taskId: getTaskData?.taskId,
          };
          submitTask(payload);
        }
      }
    } else {
      setSelectedLander({});
    }
    setAdditionalFields({});
  }, [callbackAdditionalField]);

  useEffect(() => {
    if (Object.keys(callbackReqDoc).length !== 0) {
      if (getTaskData?.taskDefinitionKey == "login_stage_process_login_task") {
        const payload = {
          taskDefinitionKey: getTaskData?.taskDefinitionKey,
          taskId: getTaskData?.taskId,
        };
        submitTask(payload);
      }
      setCallbackReqDoc({});
    }
  }, [callbackReqDoc]);

  const handlePaginationChange = (current: any, pageSize: any) => {
    const filterData = lenders?.filter((item: any) => {
      return item?.lenderName
        ?.toLowerCase()
        ?.replace(/\s/g, "")
        ?.includes(searchValue?.toLowerCase()?.replace(/\s/g, ""));
    });
    setFilterListDecision(filterData);
    setPageNo(pageSizeMain == pageSize ? current : 1);
    setPageSizeMain(pageSize);
  };

  const handleSearch = (value: any) => {
    const filterData = lenders?.filter((item: any) => {
      return item?.lenderName
        ?.toLowerCase()
        ?.replace(/\s/g, "")
        ?.includes(value?.searchParam?.toLowerCase()?.replace(/\s/g, ""));
    });
    setFilterListDecision(filterData);
    setSearchValue(value?.searchParam);
    setTotalCount(filterData?.length ?? 0);
    setPageNo(1);
  };

  const flowableResumableLender = ["icici bank", "hdfc"];

  const checkIsFlowableLender = (lenderName: string) => {
    return (
      lenderName?.toLowerCase().includes("kotak") ||
      lenderName?.toLowerCase().includes("icici") ||
      lenderName?.toLowerCase().includes("hdfc") ||
      lenderName?.toLowerCase().includes("flexi") ||
      lenderName?.toLowerCase().includes("kreditbee") ||
      lenderName?.toLowerCase().includes("moneywide") ||
      lenderName?.toLowerCase().includes("cashe") ||
      lenderName.toLowerCase().includes("nira finance") ||
      lenderName?.toLowerCase().includes("abcfl") ||
      lenderName?.toLowerCase().includes("abcl") ||
      lenderName?.toLowerCase().includes("credit saison") ||
      lenderName?.toLowerCase().includes("bajaj housing finance") ||
      lenderName?.toLowerCase().includes("prefr") ||
      lenderName?.toLowerCase().includes("incred") ||
      lenderName?.toLowerCase().includes("guardian securities private limited") ||
      (lenderName?.toLowerCase()?.includes("fibe") &&
        leadData?.loanType == "Buy Now Pay Later")
    );
  };

  const onAction = (lender: any) => {
    if (lender?.submissionType == "API") {
      setLenderObj(lender);
      setLoginOptionModal(true);
    } else {
      handleChangeScreen(lender);
    }
  };

  const onCreditCardAction=(lender:any, item:any = null) =>{
    
     if (lender?.submissionType == "API") {
      setLenderObj(lender);
      setSubProductObj(item)
      setLoginOptionModal(true);
    } else {
       handleCreditCardChangeScreen(lender, item);
    }
  }

  const handleCreditCardChangeScreen = (lender: any, item:any) => {
    const findLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
        (item) => item?.lenderInfoId == lender?.lenderInfoId
      );
      if (!findLender || [""].includes(findLender.status)) {
      updateAssignedCase(lender);
      return;
    }
    let apiIntegratedLender1 =
      findLender?.submissionType?.includes("API") &&
      (findLender.processInstanceId || findLender?.lenderApplicationId) &&
      !findLender?.allDocumentUploaded;

    if (apiIntegratedLender1) {
      setSelectedLander({ ...lender, ...findLender });
      if (checkIsFlowableLender(findLender?.lenderName)) {
        setAdditionalFields([]);
        setCurrLenderId(findLender?.lenderInfoId);
        setCurrLeadId(leadData?.caseDetails?.caseId);
        setShowAdditionalFields(true);
      } else {
        setShowRequirementDocs(true);
      }
      return;
    } else {
      getLenderAdditonalField(findLender);
      return;
    }
  };


  const handleChangeScreen = (lender: any) => {
    const findLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
        (item) => item?.lenderInfoId == lender?.lenderInfoId
      );
    if (!findLender || [""].includes(findLender.status)) {
      updateAssignedCase(lender);
      return;
    }

    let apiIntegratedLender1 =
      findLender?.submissionType?.includes("API") &&
      (findLender.processInstanceId || findLender?.lenderApplicationId) &&
      !findLender?.allDocumentUploaded;

    if (apiIntegratedLender1) {
      setSelectedLander({ ...lender, ...findLender });
      if (checkIsFlowableLender(findLender?.lenderName)) {
        setAdditionalFields([]);
        setCurrLenderId(findLender?.lenderInfoId);
        setCurrLeadId(leadData?.caseDetails?.caseId);
        setShowAdditionalFields(true);
      } else {
        setShowRequirementDocs(true);
      }
      return;
    } else {
      getLenderAdditonalField(findLender);
      return;
    }
  };

  const updateAssignedCase = (lender: any, isOffLine: boolean = false) => {
    const shouldAddSubProduct = leadData?.loanType === "Credit Card" && lender?.aggregatorConfigId != null;
    const subProductDetails = {
    productPlanId: subProductObj?.productPlanId,
  };
  setProductPlanId(subProductObj?.productPlanId)
  setSelectedLender(lender)
  const lenderDetail = {
    branchName: lender?.lenderName || "",
    hubName: "",
    lenderInfoId: lender?.lenderInfoId,
    lenderName: lender?.lenderName,
    status: "ASSIGNED",
    submissionType: lender?.submissionType,
    isOffline: isOffLine,
    ...(shouldAddSubProduct && {
      subProductDetails: { subProductDetails: [subProductDetails] },
    }),
  };
    const payload = {
      comments: null,
      lenderDetails: [lenderDetail],
    };
    updateCase(payload, { key: tenantInfo?.businessProductType === "INSURANCE" ? "INSURER_POLICY_SELECTION" : "LENDER_SELECTION" }, !isOffLine).then(() => {
      const payload1 = {
        processInstanceId: leadData?.processInstanceId,
        gotoStep: "lenderDecisionStage",
      };
      getNextTask(payload1);
    });
    // this step is used to change tab for lender decision stage
    

  };

  const renderDocumentStatus = (lender) => {
    const total = lender?.documentProgressDetails?.totalNumberOfDocs ?? 0;
    const submitted =
      lender?.documentProgressDetails?.documentsSuccessfullySubmitted ?? 0;
    const failed = lender?.documentProgressDetails?.failure ?? 0;
    return (
      <>
        {total > 0 && (submitted > 0 || failed > 0) && (
          <span
            className="checkbox-text small"
            style={{ cursor: "pointer", fontSize: "11px" }}
            onClick={() => {
              setDocumentDetails(
                lender?.documentProgressDetails?.submissionDetails
              );
              setSelectedDocLender(lender);
              setShowDocumentStatus(true);
            }}
          >
            {`Document Status: ${submitted}/${total}`}
          </span>
        )}
      </>
    );
  };

  const renderLoginUpdateStatus = () => {
    return (
      <Modal
        centered
        width={350}
        footer={null}
        visible={loginOptionModal}
        closable={false}
      >
        <div style={{ display: "grid", gap: "20px", marginTop: "20px" }}>
          <span>Select the Option</span>
          <Radio.Group
            onChange={(e) => setUpdateStatusType(e?.target?.value)}
            name="applicantType"
            className="dynamic-radio"
            style={btnRadioStyles}
          >
            <Space direction="vertical">
              <Radio value={"API"} 
              disabled = {leadData?.loanType === "Credit Card" && ((lenderObj?.aggregatorConfigId?.length ?? 0) > 0)}
              >
                {"Send Case via API"} 
              </Radio>
              <Radio value={"OFFLINE"}>
                {"Update Status of an Offline Case"}
              </Radio>
            </Space>
          </Radio.Group>
          <Space style={{ marginBottom: "20px" }}>
            <Button
              size="large"
              className="button-submit dynamic-btn-primary"
              style={customStylesBtnPrimary}
              // loading={loading}
              type="primary"
              onClick={() => {
                setLoginOptionModal(false);
                if (updateStatusType == "API") {
                  if(leadData?.loanType != "Credit Card") {
                    handleChangeScreen(lenderObj);
                  }
                  else{
                    handleCreditCardChangeScreen(lenderObj, subProductObj)
                  }
                  if (
                    getTaskData?.productFormMetadata?.stageKey != "loginStage"
                  ) {
                    const payload = {
                      processInstanceId: leadData?.processInstanceId,
                      gotoStep: "loginStage",
                    };
                    getNextTask(payload);
                    // API_SERVICE.productGetNextTask(payload);
                  }
                } else if (updateStatusType == "OFFLINE") {

                  updateAssignedCase(lenderObj, true);
                }
              }}
            >
              Submit
            </Button>
            <Button
              size="large"
              className="button-submit dynamic-btn-default"
              style={btnDefaultBorderStyle}
              htmlType="button"
              onClick={() => setLoginOptionModal(false)}
            >
              Cancel
            </Button>
          </Space>
        </div>
      </Modal>
    );
  };

  const renderLenderStatus = (
    lenderDetails: any,
    consentDetails: any,
    statusAlign: string = "",
    lender:any
  ) =>(
        <div
          style={{
            color: "#20A74E",
            gap: "10px",
            display: "flex",
            justifyContent: statusAlign,
          }}
        >
          {lenderDetails?.submissionType == "API" && !lender?.isApiFlagDisabled && (//lenderDetails?.submissionType == "API" 
            <span
              className="lender-additional-details"
              style={
                { "--appSecondary": appColors?.appSecondaryColor ?? "" } as any
              }
            >
              <IconApprove style={{width:'12px'}} />
              {(lenderDetails?.aggregatorName != null) ? `  API - ${lenderDetails?.aggregatorName}` : "API"}
            </span>
          )}
          {Object.keys(consentDetails).length > 0 && (
            <span
              className="lender-additional-details"
              style={
                { "--appSecondary": appColors?.appSecondaryColor ?? "" } as any
              }
            >
              <IconApprove /> Consent
            </span>
          )}
        </div>
      );
    
    
const renderLenderStatus1 = (
    lenderDetails: any,
    statusAlign: string = ""
  ) => (
    <div
      style={{
        color: "rgba(66, 133, 244, 1)",
        textDecoration:'underline',
        gap: "10px",
        display: "flex",
        justifyContent: statusAlign,
      }}
    >
      
      {lenderDetails?.lenderLoginUrl && (
     <> 
     <a
      onClick={() => window.open(lenderDetails.lenderLoginUrl, "_blank")}
      style={{ fontSize: "11px", textDecoration:'underline' }} 
    >
      Lender Link  
      </a>

      <img
          src={copyIcon}  
          alt="Copy Icon"
          style={{ width: "10px", height: "16px", cursor: "pointer", marginLeft: "-6px" }}
          onClick={() => {
            navigator.clipboard.writeText(lenderDetails.lenderLoginUrl);
            
          }}
        />
   
    
    
    </>
    
       
    )}

    </div>
  );


  const renderCopyiLeansId = (lenderDetails: any) => (
    <div className="checkbox-text-div">
      {lenderDetails?.submissionType?.includes("API") &&
        lenderDetails?.additionalFields?.ilensId?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              className="lender-additional-details"
              style={{ "--appSecondary": "black" } as any}
            >{`iLens ID: ${
              JSON.parse(lenderDetails?.additionalFields)?.ilensId
            }`}</span>
            <Button
              style={{
                borderColor: "transparent",
                background: "transparent",
                fontSize: "12px",
              }}
              size="small"
              shape="circle"
              onClick={() => {
                navigator.clipboard.writeText(
                  JSON.parse(lenderDetails?.additionalFields)?.ilensId ?? ""
                );
                notification.success({ message: "Copied to clipboard" });
              }}
              icon={<img src={iconCopy} alt="" width={10} height={10} />}
            />
          </div>
        )}
    </div>
  );

  const isLenderLogged = (findLender) => {
    const isDocUploaded =
      findLender?.submissionType != "API" ||
      (findLender?.submissionType == "API" &&
        findLender?.allDocumentUploaded) ||
      ["REJECTED", "WITHDRAWN", "PENDENCY"].includes(findLender?.status);
    const isLogged =
      isDocUploaded &&
      ["LOGGED", "SANCTIONED", "DISBURSED"].includes(findLender?.status);
    return isLogged;
  };

  const renderRedirectLink = (lenderDetails: any) => (
    <>
      {lenderDetails?.submissionType?.includes("API") &&
        (lenderDetails?.lenderApplicationId?.length ?? 0) > 0 && (
          <span className="flex" style={{ display: "flex" }}>
            {(["BU9709497975", "BU3620294738"].includes(
              lenderDetails.lenderInfoId
            ) ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("fibe") ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("moneywide") ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("cashe") ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("kreditbee") ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("abcfl") ||
              lenderDetails?.lenderName?.toLowerCase()?.includes("abcl") ||
              ((lenderDetails?.lenderName?.toLowerCase()?.includes("prefr") ||
                lenderDetails?.lenderName?.toLowerCase()?.includes("incred")) &&
                isLenderLogged(lenderDetails)) ||
              lenderDetails?.lenderName
                .toLowerCase()
                .includes("nira finance") ||
                lenderDetails?.lenderName
                .toLowerCase()
                .includes("guardian securities private limited") ||
              lenderDetails?.lenderName
                ?.toLowerCase()
                ?.includes("credilio") ||
                lenderDetails?.lenderName
                ?.toLowerCase()
                ?.includes("loan tap")) && (
              <>
                <a
                  onClick={() =>
                    getRedirectURLLink(
                      lenderDetails?.lenderInfoId,
                      leadData?.loanProductId,
                      lenderDetails?.lenderApplicationId
                    )
                  }
                  className="small"
                  style={{ fontSize: "12px" }}
                >
                  {`Lender Link`}
                </a>
                <Button
                  size="small"
                  style={{ margin: "2px", border: "none" }}
                  onClick={() =>
                    getRedirectURLLink(
                      lenderDetails?.lenderInfoId,
                      leadData?.loanProductId,
                      lenderDetails?.lenderApplicationId,
                      true
                    )
                  }
                  icon={
                    <img
                      src={shareIcon}
                      alt=""
                      width={18}
                      height={18}
                      style={{ marginTop: "-4px" }}
                    />
                  }
                />
              </>
            )}
          </span>
        )}
    </>
  );

  const renderLenderNames = (rec: any) => {
    const findLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
        (item) => item?.lenderInfoId == rec?.lenderInfoId
      );
      
    let isBulkLogin = findLender?.isBulkLogin
    let consentDetails: any = {};
    if ((findLender?.consentDetails?.length ?? 0) > 0) {
      consentDetails = JSON.parse(findLender?.consentDetails ?? {});
    }
    return (
      <div style={{ display: "grid", justifyContent: "left" }}>
        <span style={{ fontSize: "13px", textAlign: "start" }}>
          {rec?.lenderName}
        </span>
        {isBulkLogin && 
          <span          
            style={
              { lineHeight:'15px', fontSize:'10px'
            }}
          >
          (Bulk Login)
        </span>
        }
        {rec.showPAPQTextOnLender && 
          <span          
            style={
              { lineHeight:'15px', fontSize:'10px'
            }}
          >
          <IconApprove /> Pre Qualified
        </span>
        }
         
        {renderLenderStatus(rec, consentDetails, "left", findLender)}
        
        {(findLender?.lenderApplicationId?.length ?? 0) > 0 && (
          <span
            className="lender-additional-details"
            style={{ "--appSecondary": "black" } as any}
          >
            Lender Loan ID: {findLender?.lenderApplicationId}
          </span>
        )}
        {(findLender?.additionalFields?.length ?? 0) > 0 &&
          (findLender?.lenderName?.toLowerCase()?.includes("incred") || findLender?.lenderName?.toLowerCase()?.includes("guardian securities private limited")) && (
            <span
              className="lender-additional-details"
              style={{ "--appSecondary": "black" } as any}
            >
              Customer ID: {JSON.parse(findLender?.additionalFields).customerId}
            </span>
          )}
        {renderCopyiLeansId(findLender)}
        {renderDocumentStatus(findLender)}
        {renderRedirectLink(findLender)}
        {renderLenderStatus1(rec, "left")}
      </div>
    );
  };

  const renderCardNames=(record)=>{
    return record?.lenderSubProductOfferDetailsList?.map((item, index) => {
      const offerDetail =
        item?.aggregatorOfferDetails?.aggregatorOfferDetails?.[0]?.offerDetails;
      let prodPlanId = item?.productPlanId
      let cardDetails = lenderListInsurer
      ?.flatMap((lender) => lender.productPlanDetails || [])
      .find((plan) => plan.productPlanId === prodPlanId);
      return(
        <div key={index}>
        <div>{cardDetails?.productPlanName}</div>
        <Space>
          <span>
            <a
              onClick={() => {
                setOfferDetails(offerDetail)
                setShowCardFeatures(true);
              }}
              className="cardName-link"
            >
              Features
            </a>
          </span>
          <Divider type="vertical" />
          <a
            onClick={() => window.open(offerDetail?.apply_link, "_blank")}
            className="cardName-link"
          >
            Apply Link
          </a>
        </Space>
      </div>
      )      
    });
   }
  
  const colAction = (_: any, record: any) => {
    const findLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
        (item) => item?.lenderInfoId == record?.lenderInfoId
      );
       if(leadData?.loanType !== "Credit Card" || record?.aggregatorConfigId === null){
        const isDocUploaded =
        findLender?.submissionType != "API" ||
        (findLender?.submissionType == "API" &&
        findLender?.allDocumentUploaded) ||
        ["REJECTED", "WITHDRAWN", "PENDENCY"].includes(findLender?.status);
        const isLogged =
          [
            "SANCTIONED",
            "DISBURSED",
            "PENDENCY",
            "REJECTED",
            "WITHDRAWN",
            "POLICY_ISSUED",
            "UNDERWRITING_REJECT",
            "COUNTER_OFFER",
          ].includes(findLender?.status) ||
          (isDocUploaded &&
          [
            "LOGGED",
            "SANCTIONED",
            "DISBURSED",
            "PENDENCY",
            "REJECTED",
            "WITHDRAWN",
            "POLICY_ISSUED",
            "UNDERWRITING_REJECT",
            "COUNTER_OFFER",
          ].includes(findLender?.status));

    return (
      <>
        {isLogged ? (
          <>
            <img src={iconApprove} width={20} />
            <br />
            <span style={{ fontSize: "11px" }}>LOGGED</span>
          </>
        ) : (
          <Button
            style={{ background: "transparent", border: "none" }}
            type="text"
            size="small"
            onClick={() => onAction(record)}
            icon={
              <img
                src={iconAction}
                alt=""
                width={24}
                height={24}
                style={{ marginTop: "-4px" }}
              />
            }
          />
        )}
      </>
    );
  }
  else{
    return (
      <>
        {(record?.lenderSubProductOfferDetailsList?.length ?? 0) > 0 ? (
          record.lenderSubProductOfferDetailsList.map((item, index) => (
            <div key={index}>
              {renderLenderStatusAction(record, item)}
            </div>
          ))
        ) : (
          renderLenderStatusAction(record)
        )}
      </>
    );

  }
};

const renderLenderStatusAction = (lender: any, item:any = null) => {
   const findLender =
    leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
      (rec) => rec?.lenderInfoId === lender?.lenderInfoId
    );
    const findSubProduct = leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.map((item)=>item?.subProductDetails?.subProductDetails)
    const flatSubProducts = findSubProduct?.flat();
    const subProduct = flatSubProducts?.find(
      (prod) => prod?.productPlanId === item?.productPlanId
    );
    
    const isProductPlanEmpty = !(subProduct?.productPlanId?.trim().length > 0);
   const isLoggedSubProduct = !isProductPlanEmpty
    const isDocUploaded =
    findLender?.submissionType != "API" ||
    (findLender?.submissionType == "API" &&
    findLender?.allDocumentUploaded) ||
    ["REJECTED", "WITHDRAWN", "PENDENCY"].includes(findLender?.status);
    const isLogged =
      [
        "SANCTIONED",
        "DISBURSED",
        "PENDENCY",
        "REJECTED",
        "WITHDRAWN",
        "POLICY_ISSUED",
        "UNDERWRITING_REJECT",
        "COUNTER_OFFER",
      ].includes(findLender?.status) ||
      (isDocUploaded &&
      [
        "LOGGED",
        "SANCTIONED",
        "DISBURSED",
        "PENDENCY",
        "REJECTED",
        "WITHDRAWN",
        "POLICY_ISSUED",
        "UNDERWRITING_REJECT",
        "COUNTER_OFFER",
      ].includes(findLender?.status));

  return (isLoggedSubProduct || (findLender?.subProductDetails === null  && isLogged)) ? (
    <>
      <img src={iconApprove} width={20} />
      <br />
      <span style={{ fontSize: "11px" }}>LOGGED</span>
    </>
  ) : (
    <Button
      style={{ background: "transparent", border: "none" }}
      type="text"
      size="small"
      onClick={() => onCreditCardAction(lender, item)}
      icon={
        <img
          src={iconAction}
          alt=""
          width={24}
          height={24}
          style={{ marginTop: "-4px" }}
        />
      }
    />
  );
};

  const columns: ColumnsType<any> = [
    {
      title: "Lender Name",
      dataIndex: "lenderName",
      align: "left",
      width: 0,
      sorter: (a: any, b: any) => a.lenderName.localeCompare(b.lenderName),
      render: (_: any, rec: any) => renderLenderNames(rec),
      // onCell: (value: any) => {
      //   return { rowSpan: value?.rowSpan ?? 1 };
      // },
    },
    {
      title: "Card Name",
      dataIndex: "cardName",
      key: "cardName",
      align: "left",
      width: 0,
      render: (_: any, record: any) => renderCardNames(record)
    },
    {
      title: "Purpose",
      dataIndex: "decisioningPurpose",
      render: (value: any, rec: any) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={commonFontSize}>
              {getEnumValue("DECISIONING_PURPOSE", value ?? "")}
            </span>
            {(rec?.errorWhileCalculatingOffer?.length ?? 0) > 0 && (
              <Tooltip title={rec?.errorWhileCalculatingOffer}>
                <img src={iconError} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Gating Eligibility Passed",
      dataIndex: "gatingPassed",
      key: "gatingPassed",
      align: "center",
      width:170,
      render: (_: any, record: any) => {
        return (
          <>
           {record?.gatingPassed === null || record?.gatingPassed===undefined ? 
           ("") : (
          record?.gatingPassed ? (
            <img src={passIcon} alt="" />
          ) : (
            <img src={failIcon} alt="" />
          )
        )}
          </>
        );
      },
    },
    {
      title: "Score",
      dataIndex: "score",
      render: (rec: any) => <span style={commonFontSize}>{rec}</span>,
    },
    {
      title: "Max Loan Amount",
      dataIndex: "maxLoanAmount",
      sorter: (a: any, b: any) => a.maxLoanAmount - b.maxLoanAmount,
      render: (rec: any) => {
        if (rec == null) {
          return <></>;
        }
        return <span style={commonFontSize}>Rs. {numberWithCommas(rec)}</span>;
      },
    },
    {
      title: "Total EMI",
      dataIndex: "totalEmi",
      render: (rec: any) => <span style={commonFontSize}>{rec}</span>,
    },
    {
      title: "Tenure (in years)",
      dataIndex: "tenureInMonths",
      render: (rec: any) => <span style={commonFontSize}>{rec}</span>,
    },
    {
      title: "ROI %",
      dataIndex: "roi",
      render: (rec: any) => <span style={commonFontSize}>{rec}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      render: colAction,
    },
  ];

  const columnsInsurance: ColumnsType<any> = [
    {
      title: "Insurer Name",
      dataIndex: "lenderName",
      align: "left",
      sorter: (a: any, b: any) => a.lenderName.localeCompare(b.lenderName),
      render: (_: any, rec: any) => renderLenderNames(rec),
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      render: (_: any, rec: any) => {
        const findLender =
          leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
            (item) => item?.lenderInfoId == rec?.lenderInfoId
          );
        const plans = findLender?.insuranceDetails?.insuranceDetails?.map(
          (insure: any) => insure?.policyNumber
        );
        const plan = plans?.filter((plan: any) => plan)?.join(", ");
        return <span style={commonFontSize}>{plan}</span>;
      },
    },
    {
      title: "Proposal Application Number",
      dataIndex: "proposalApplicationNumber",
      render: (_: any, rec: any) => {
        const findLender =
          leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
            (item) => item?.lenderInfoId == rec?.lenderInfoId
          );
        const plans = findLender?.insuranceDetails?.insuranceDetails
          ?.map((insure: any) => insure?.proposalApplicationNumber)
        const plan = plans?.filter((plan: any) => plan)?.join(", ");
        return <span style={commonFontSize}>{plan}</span>;
      },
    },
    {
      title: "Product Plan",
      dataIndex: "productPlan",
      render: (_: any, rec: any) => {
        const findLender =
          leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
            (item) => item?.lenderInfoId == rec?.lenderInfoId
          );
        const plan = findLender?.insuranceDetails?.insuranceDetails
          ?.map((insure: any) => insure?.productPlanName)
          ?.join(", ");
        return <span style={commonFontSize}>{plan}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      render: colAction,
    },
  ];

  const customStylesBtnPrimary: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
  };
  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };
  const btnRadioStyles: any = {
    "--borderColor": appColors?.appPrimaryColor ?? "",
  };
  const btnDefaultBorderStyle: any = {
    "--borderColor": appColors?.appSecondaryColor ?? "",
  };

 
const renderFeaturesAsParagraphs = (cardFeatures: string) => {
  if (!cardFeatures) return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(cardFeatures, "text/html");
  const liElements = Array.from(doc.querySelectorAll("li"));

  interface Section {
    title: string;
    items: string[];
  }

  const sections: Section[] = [];
  let currentSection: Section | null = null;

  liElements.forEach((li) => {
    const strong = li.querySelector("strong");
    const strongText = strong?.textContent?.trim();
    const fullText = li.textContent?.trim() || "";

    if (strongText) {
      if (currentSection) sections.push(currentSection);

      const title = strongText.replace(/:$/, "");
      const remainingText = fullText.replace(strongText, "").trim();

      currentSection = {
        title,
        items: remainingText ? [remainingText] : [],
      };
    } else if (currentSection) {
      currentSection.items.push(fullText);
    }
  });
  if (currentSection) {
    sections.push(currentSection);
  }

  return (
    <div>
      {sections.map((section, idx) => (
        <div key={idx} style={{ marginBottom: "16px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "4px" }}>{section.title}</p>
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            {section.items.map((item, i) => (
              <li key={i} style={{ fontSize: "14px", lineHeight: "1.6" }}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};


const renderCreditCardFeatures =()=>{
 
  return(
    <Modal 
        title="Features"
        closable
        visible={showCardFeatures}
        onCancel={()=>setShowCardFeatures(false)}
        footer={false}
        width={700}      
    >
      <div>
          <Space>
            <div style={{display:"flex", alignItems:"flex-start"}}>
                <img src={offerDetails?.card_image} style={{height:"450px", width:'225px', marginTop:"-90px"}} alt="card"/>
            </div>
            <div>
                <Title 
                    level={4}
                >
                    {offerDetails?.card_name} 
                </Title>
                <p style={{border:"1px solid lightgrey", borderRadius:"5px", paddingLeft:"30px", paddingTop:"10px", paddingBottom:"10px"}}>
                    Annual Fee: <b>{offerDetails?.annual_fee}</b>
                </p>
                <div>
                  {renderFeaturesAsParagraphs(offerDetails?.features)}
                </div>
              </div>
            
          </Space>
      </div>

    </Modal>
  )
}

  const handleRefresh=()=>{
    loginSearchForm.setFieldsValue({
      searchParam: "",
    });
    setPageNo(1);
    setSearchValue("");
    setFilterListDecision([]);
    getLenders(true);
  }

  const getColumn = () => {
    let col = columns;
    if(leadData?.loanType != "Credit Card") {
      col = columns.filter((col) => col.key !== "cardName")
    }
    return tenantInfo?.businessProductType === "INSURANCE" ? columnsInsurance : col
  }
  
  return (
    <>
      {renderCreditCardFeatures()}
      {showDocumentStatus && (
        <DocumentStatus
          showDocumentStatus={showDocumentStatus}
          setShowDocumentStatus={setShowDocumentStatus}
          lenderInfoId={selectedDocLender?.lenderInfoId}
          caseId={leadData?.caseDetails?.caseId}
          documentDetails={documentDetails}
        />
      )}

      <Form
        form={loginSearchForm}
        layout="inline"
        style={{ padding: "10px" }}
        onFinish={handleSearch}
      >
        
        <Form.Item name="searchParam" label={tenantInfo?.businessProductType === "INSURANCE" ? "Insurer Selection" : "Decisioning/Lender Selection"}>
          <Input
            size="large"
            style={{ borderRadius: "8px" }}
            prefix={<img src={iconSearch} alt="" width={17} />}
            placeholder={"Search " + (tenantInfo?.businessProductType === "INSURANCE" ? "Insurer" : "Lender")}
            allowClear
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="dynamic-btn-primary"
            style={customStylesBtnPrimary}
          >
            Search
          </Button>
        </Form.Item>
        <div className="action-button" style={{color:"blue", marginLeft:"5px", float:"right", right:"0px", position:"absolute"}}>
              <Button
                icon={<IconRefresh className="refresh-icon"/>}
                onClick={handleRefresh}
              >
                <span style={{color:"#273896"}}>Refresh</span>
              </Button>
        </div>
        
      </Form>
      <Table
        columns={getColumn()}
        className="table-bg-transparent dynamic-pagination-checkbox"
        style={customStyles}
        dataSource={
          (filterListDecision?.length ?? 0) > 0 ? filterListDecision : lenders
        }
        size="small"
        onChange={(pagination: any) => {
          handlePaginationChange(pagination.current, pagination.pageSize);
        }}
        pagination={{
          current: pageNo,
          pageSize: pageSizeMain,
          total: totalCount,
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        bordered
      />
      {loginOptionModal && renderLoginUpdateStatus()}
      {/* {showGlobalLender && (
        <LenderSelection
          leadData={leadData}
          onAction={(lender: any) => onAction(lender)}
          lenderNextHandler={lenderNextHandler}
          listDecisionData={listDecisioningData}
          setIsLoading={setIsLoading}
          loading={loading}
          renderLenderStatus={renderLenderStatus}
          renderDocumentStatus={renderDocumentStatus}
          renderCopyiLeansId={renderCopyiLeansId}
          renderRedirectLink={renderRedirectLink}
        />
      )} */}
    </>
  );
};

export default Login;
